import { render, staticRenderFns } from "./WelfareAttendanceFixDialog.vue?vue&type=template&id=5d6967de&scoped=true"
import script from "./WelfareAttendanceFixDialog.vue?vue&type=script&lang=js"
export * from "./WelfareAttendanceFixDialog.vue?vue&type=script&lang=js"
import style0 from "./WelfareAttendanceFixDialog.vue?vue&type=style&index=0&id=5d6967de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6967de",
  null
  
)

export default component.exports